import {forEach, replace} from 'lodash';
import * as moment from 'moment';
import OzwolImageService from "./services/OzwolImageService";
import axios from "axios";

export const slugify = (name, id = null) => {
  name = name.replace(/^\s+|\s+$/g, ''); // trim
  name = name.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
      name = name.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  name = name.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

  let slug;
  if(id){
    slug = name + "-" + id;
  }else{
    slug = name;
  }
  return slug;
}

export const replaceStrWithObj = (str, obj) => {

  forEach(obj, function (value, key) {
    str = replace(str, `${key}`, value);
  });
  return str;

}

//Contatto diretto all'espositore: disattivato.
//Prevedeva un destinatario e un corpo HTML costruiti dal client, cioè esattamente
//ciò che rendeva /api/sendmail utilizzabile come relay: il server ora accetta solo
//il flusso segnalazioni (type=complaint) e rifiuta questo.
//ContactForm è mantenuto ma non è raggiungibile dalla UI (il pulsante "Contact"
//delle schede apre un mailto:, non la modale). Per riattivare la funzionalità serve
//prima la controparte server-side che ricavi il destinatario dall'id espositore.
export const sendMail = () => Promise.reject(new Error('exhibitor-contact-disabled'));

//Invio segnalazione/reclamo.
//Il server costruisce oggetto, corpo e destinatario (vedi functions/custom_modules/mailTemplates.js):
//qui passiamo solo i dati del form. I parametri sono codificati con URLSearchParams,
//non concatenati a mano: la concatenazione precedente permetteva di iniettare
//parametri aggiuntivi (es. "&emailTo=...") dentro il testo del messaggio.
export const sendComplaintMail = ({fromName, fromEmail, pageUrl, reason, reCaptcha, lang = 'it', config}) => {

  const params = new URLSearchParams({
    type: 'complaint',
    tenant: config.tenant || '',
    lang: lang || 'it',
    fromName: fromName || '',
    fromEmail: fromEmail || '',
    pageUrl: pageUrl || '',
    reason: reason || '',
    'g-recaptcha-response': reCaptcha || ''
  });

  return axios.post(config.sendmail.endpoint, params, {
    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
  }).then(response => {
    if (!response || !response.data || response.data.valid !== true) {
      throw new Error('complaint-not-sent');
    }
    return response.data;
  });

}

export const sortArrayNumbers = (array, order = 'asc') => array.sort((a, b) => order === 'asc' ? (a - b) : (b - a));

const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

export const scrollTo = (element, to, duration) => {

  if (!element) return;

  var start = element.scrollTop,
    change = to - start,
    currentTime = 0,
    increment = 20;

  var animateScroll = function () {
    currentTime += increment;
    var val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};

export const stripTags = string => string.replace(/(<([^>]+)>)/ig, "");

export const getLetzfairAuthData = async () => {
  const endpoint = process.env.NODE_ENV === 'production'
    ? 'https://deevent-api.24apps.it'
    : 'https://deevent-api-dev.24apps.it';

  const response = await axios.post(`${endpoint}/v1/LetzfairAuth`);

  if (!response?.data?.checkString) {
    throw new Error('Unable to get Letzfair auth data');
  }

  return response?.data;
};

export const refreshLetzfairAuthData = async (forceRefresh = false) => {
  const REFRESH_DELTA = 5 * 60 * 1000; // 5 minuti in millisecondi
  const now = Date.now();
  
  if (!window._letzfair) {
    window._letzfair = {};
  }

  // Controlla se è necessario fare il refresh (non esiste, è scaduto o forzato)
  // timestamp dall'API è in secondi, quindi lo moltiplichiamo per 1000
  const needsRefresh = forceRefresh || 
                      !window._letzfair.timestamp || 
                      (now - (window._letzfair.timestamp * 1000)) > REFRESH_DELTA;

  if (needsRefresh) {
    try {
      const letzfairAuthData = await getLetzfairAuthData();
      window._letzfair.timestamp = letzfairAuthData.timestamp;
      window._letzfair.check_api_key = letzfairAuthData.checkString;
      if (letzfairAuthData.token) {
        window._letzfair.token = letzfairAuthData.token;
      }
      console.log('[LETZFAIR] Auth data refreshed');
      return true; // Indica che è stato fatto il refresh
    } catch (error) {
      console.error('[LETZFAIR] Error refreshing auth data:', error);
      throw error;
    }
  } else {
    console.log('[LETZFAIR] Auth data still valid, skipping refresh');
    return false; // Indica che non è stato necessario il refresh
  }
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const chatReadableDate = (timestamp, alwaysShowDate = false, translations = {
  yesterday: 'Ieri',
}, locale = 'it') => {
  const today = moment();
  const compare = moment.unix(parseInt(timestamp));
  const daysDiff = today.diff(compare, 'days');
  const hour = compare.format('HH:mm');
  if (today.day() === compare.day()) {
    return (alwaysShowDate ? '' : '') + hour;
  } else if (daysDiff === 0 && today.day() !== compare.day()) {
    return `${translations.yesterday} ${hour}`;
  } else if (daysDiff > 1 && daysDiff <= 7) {
    return `${compare.format('dddd', {locale})} ${hour}`;
  }
  return `${compare.format('D/M/YYYY', {locale})} ${hour}`;
};

export const getDateFormat = (timestamp) => {
  const compare = moment.unix(parseInt(timestamp));
  const hour = compare.format('HH:mm');
  return `${compare.format('DD/MM/YYYY')} ${hour}`;
};

export const getTranslation = (translations, segments) => {
  let translation = {...translations};
  try {
    translation = segments.reduce((acc, item) => acc[item], translations)
  } catch (e) {
    return `# ${segments.join(" > ")}`
  }
  if (!translation) return `# ${segments.join(" > ")}`;
  return translation

}

export const getQueryStringFromObject = (object) => {

  return Object.keys(object).reduce((acc, key) => [...acc, `${key}=${object[key]}`], []).join('&')

}

export const getChildFilters = (obj, key, keys = []) => !obj.hasOwnProperty('properties') ? [...keys, key] : Object.keys(obj.properties).reduce((acc, key2) => [...acc, ...getChildFilters(obj.properties[key2], key2, [])], [key])

export const getProductActiveChat = (activeCompanies, data) => {
  if (!activeCompanies || !data) return false;
  const exhibitorId = data.scope.exhibitorId;
  return activeCompanies && exhibitorId && activeCompanies.hasOwnProperty(exhibitorId) && activeCompanies[exhibitorId]
}

export const parseItemGallery = async (gallery) => {

  let images =  gallery.map((item, index) => {
      let source = item.src.replace("/gallery_zoom/", "/gallery_thumb/").split("/");
      return {
        name: index+"",
        sourceType: "CDN",
        source: source[source.length - 2] + "/" + source[source.length - 1]
      }
    });
  const galleryResult = await OzwolImageService.getImagesSize(images);
  // console.log("asd");
  // console.log(galleryResult);
  return gallery.map((item, index) => ({
    ...item,
    width: galleryResult[index].width,
    height: galleryResult[index].height,
  }));

}
